//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    backgroundDesktopImage: {
      type: Object,
      default: null,
    },
    backgroundDesktopX2Image: {
      type: Object,
      default: null,
    },
    backgroundMobileImage: {
      type: Object,
      default: null,
    },
    backgroundMobileX2Image: {
      type: Object,
      default: null,
    },
    backgroundDesktopColor: {
      type: String,
      default: null,
    },
    backgroundMobileColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    srcSetObject() {
      const backgroundDesktopImage = this.backgroundDesktopImage;
      const backgroundDesktopX2Image = this.backgroundDesktopX2Image;
      const backgroundMobileImage = this.backgroundMobileImage;
      const backgroundMobileX2Image = this.backgroundMobileX2Image;

      const desktopUrl = backgroundDesktopImage && backgroundDesktopImage.url;
      const desktopX2Url =
        backgroundDesktopX2Image && backgroundDesktopX2Image.url;
      const mobileUrl = backgroundMobileImage && backgroundMobileImage.url;
      const mobileX2Url =
        backgroundMobileX2Image && backgroundMobileX2Image.url;

      const desktop = desktopUrl ? `${desktopUrl} 1x` : null;
      const desktopX2 = desktopX2Url ? `${desktopX2Url} 2x` : null;
      const mobile = mobileUrl ? `${mobileUrl} 1x` : null;
      const mobileX2 = mobileX2Url ? `${mobileX2Url} 2x` : null;

      return Object.entries({
        desktop: [desktop, desktopX2],
        mobile: [mobile, mobileX2],
      }).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: value.filter((i) => i).join(', '),
        }),
        {},
      );
    },
  },
};
